import React from "react";
import { Outlet } from "react-router-dom";
import SalesSidebar from "./SalesSidebar";

export default function SalesLayout() {
  return (
    <div className="flex min-h-screen" style={{ background: "#F7F8F6" }}>
      <SalesSidebar />
      <main className="flex-1 min-w-0"><Outlet /></main>
    </div>
  );
}
